/** Anchura mínima, en píxeles, por cada unidad de peso de una columna. Se prefiere que sobre espacio
 * y haya scroll a que se corte nada: por debajo de 100 se cortan en Pedidos el botón del nº de pedido
 * y el correo de Responsable. */
export const ANCHO_POR_PESO = 120;

/**
 * Anchura mínima de la tabla para las columnas mostradas, dados sus pesos (su flex-grow).
 *
 * Las columnas se reparten el ancho según su peso y, sin un mínimo, en una pantalla estrecha se
 * aprietan hasta que no se lee nada. Con este mínimo en la tabla, cada columna conserva al menos
 * ANCHO_POR_PESO píxeles por unidad de peso y lo que no cabe se ve con scroll horizontal. En
 * pantallas anchas no cambia nada: la tabla sigue ocupando el ancho disponible.
 */
export function anchoMinimoTabla(pesos: (number | null | undefined)[]): number {
    return pesos.reduce<number>((total, peso) => total + (peso > 0 ? peso : 1) * ANCHO_POR_PESO, 0);
}
